import React from 'react';

import { LabeledValueField } from 'components/fields';
import { capitalize } from 'services/helpers/formatters';

const formatInterceptionType = (interceptionType?: string) =>
  interceptionType ? capitalize(interceptionType.replace(/_/g, ' ')) : '---';

const formatInterceptedAt = (interceptedAt?: string) => {
  if (!interceptedAt) {
    return '---';
  }

  const date = new Date(interceptedAt);

  if (isNaN(date.getTime())) {
    return interceptedAt;
  }

  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  });
};

const InterceptionSection = (props) => (
  <>
    <LabeledValueField
      {...props}
      label="Interception type"
      source="interceptionType"
      formatter={formatInterceptionType}
    />
    <LabeledValueField
      {...props}
      label="Intercepted at"
      source="interceptedAt"
      formatter={formatInterceptedAt}
    />
  </>
);

export default InterceptionSection;
